<template>
  <b-form @submit.prevent="handleSubmit" class="p-2">
    <b-form-row>
      <b-col
        cols="12"
        md="2"
        class="text-md-right font-weight-bold"
      >
        To:
      </b-col>
      <b-col cols="12" md="9" lg="10">{{ receiverName }}</b-col>
    </b-form-row>
    <b-form-group
      class="mt-3"
      label-cols="12"
      label-align="left"
      label-cols-md="2"
      label-align-md="right"
      label-class="font-weight-bold"
      label="Subject:"
      :state="validateState('subject')"
      :invalid-feedback="subjectInvalidFeedback"
    >
      <b-form-input
        v-model="$v.subject.$model"
        :state="validateState('subject')"
      />
    </b-form-group>
    <b-form-group
      label-cols="12"
      label-align="left"
      label-cols-md="2"
      label-align-md="right"
      label-class="v2_font_weight_semibold"
      label="Message:"
      :state="validateState('body')"
      :invalid-feedback="requiredInvalidFeedback"
    >
      <b-form-textarea
        rows="4"
        v-model="$v.body.$model"
        :state="validateState('body')"
      />
    </b-form-group>
    <b-form-row>
      <b-col
        cols="12"
        class="d-flex justify-content-start justify-content-md-end"
      >
        <b-button variant="v3_teal_outline" @click="$emit('cancel')" class="mr-4">
          Cancel
        </b-button>
        <b-button type="submit" variant="v3_teal_outline" :disabled="createMsgLoading" class="message-send-button">
          <b-spinner v-if="createMsgLoading" small />
          <span v-else>Send</span>
        </b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength } from 'vuelidate/lib/validators';
import validateStateMixin from '@/mixins/validateStateMixin';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
export default {
  name: 'MessageForm',
  mixins: [validationMixin, validateStateMixin],
  props: {
    receiverName: {
      type: String,
      default: '',
    },
    replyOnMsg: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    matchId: [String, Number],
  },
  data: function () {
    return {
      subject: this.replyOnMsg ? `Re: ${this.replyOnMsg.subject}` : null,
      body: null,
      createMsgLoading: false,
    };
  },
  validations: {
    subject: {
      required,
      maxLength: maxLength(255),
    },
    body: {
      required,
    },
  },
  computed: {
    requiredInvalidFeedback: function () {
      return 'This field is required.';
    },
    subjectInvalidFeedback: function () {
      return !this.$v.subject.maxLength
        ? `Max subject length is ${this.$v.subject.$params.maxLength}`
        : this.requiredInvalidFeedback;
    },
  },
  methods: {
    handleSubmit: async function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      try {
        this.createMsgLoading = true;
        const msgData = {
          subject: this.subject,
          body: this.body,
        };
        if (this.replyOnMsg) {
          msgData.replyId = this.replyOnMsg.id;
        }
        const newMsg = await Api.createNewMessage(this.matchId, msgData);
        this.$emit('new-msg-created', newMsg);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.createMsgLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables_mixins';

.message-send-button {
  background-color: #FFFFFF !important;
  color: $phairify_v2_color_primary_teal !important;
  &:hover {
    color: #FFFFFF !important;
    background-color: $phairify_v2_color_primary_teal !important;
  }
  border: 1px solid $phairify_v2_color_primary_teal !important;
  border-radius: 0;
  min-width: 80px !important;
}
</style>
